import {Participant} from '../../../api/booking/types'
import {SubscriptionCard, SubscriptionCardProps} from '../../../components/subscription-card/subscription-card'
import {LabeledSection} from '../../../ui/components/labeled-section/labeled-section'
import {useLocale} from '../../../utils/i18n'

export const SubscriptionSection = ({
  isLoading,
  firstParticipant,
  usageData,
}: {
  isLoading: boolean
  usageData?: SubscriptionCardProps['usage']
  firstParticipant:
    | (Participant & { membership?: { logo: { secure_url: string }; name: string } })
    | undefined
}) => {
  const {l} = useLocale()
  if (!firstParticipant?.membership) {
    return null
  }
  return (
    <>
      <LabeledSection label={l('subscription')}></LabeledSection>
      <SubscriptionCard
        styleType='summary'
        isLoading={isLoading}
        usage={usageData}
        imageUrl={firstParticipant.membership.logo.secure_url}
        name={firstParticipant.membership.name}
      />
    </>
  )
}
